<template>
  <div class="contentBlock">
    <el-container>
      <el-header>
        <div class="search">
          <header id="title">| 筛选条件</header>
          <div class="form">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="输出类型：">
                <el-select
                  v-model="formInline.transactionType"
                  style="width: 100px"
                >
                  <el-option label="充值" value="1"></el-option>
                  <el-option label="支出" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="人员：" class="people">
                <div>
                  <el-select
                    v-model="formInline.checkedPerson"
                    style="width: 100px"
                    clearable
                  >
                    <el-option label="所有" value=""></el-option>
                    <el-option
                      v-for="(peopleObj, pIndex) in peopleArr"
                      :key="pIndex"
                      :label="peopleObj.vipCode"
                      :value="peopleObj.vipCode"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <el-button
                    icon="el-icon-search"
                    @click="showUserDialog"
                    class="search-icon"
                  ></el-button>
                </div>
              </el-form-item>

              <el-form-item label="时间范围:" style="margin-left: 56px">
                <el-date-picker
                  v-model="formInline.checkedTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(formInline.checkedTime)"
                  clearable
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="批次：">
                <el-select
                  v-model="formInline.checkedBatch"
                  style="width: 180px"
                  remote
                  @change="batchChange"
                  @clear="clearChecked"
                  :remote-method="remoteMethod"
                  reserve-keyword
                  filterable
                  :loading="loading"
                  clearable
                  placeholder="请输入批次"
                  
                >
                  <el-option
                    v-for="batchObj in batchArr"
                    :key="batchObj.sendId"
                    :label="batchObj.remark"
                    :value="batchObj.remark"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="search"
                  >筛选数据</el-button
                >
                <el-button type="primary" size="small" @click="exportToExcel()">导出</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-header>
      <el-main style="margin-top: 100px; box-sizing: border-box">
        <div class="bodyContent">
          <div class="navCalss" v-if="showWhichTable == 1">
            | 流水页-充值/支出
          </div>
          <!-- <div class="navCalss" v-if="showWhichTable == 2">| 人员列表</div> -->
          <!-- 表格部分 -->

          <div class="table">
            <div class="table_in" style="max-width: 1700px">
              <!-- 流水表格start -->
              <el-table
                v-if="showWhichTable == 1"
                :data="tableData"
                stripe
                max-height="600px"
              >
                <el-table-column
                  prop="balanceNo"
                  label="充值账单流水号"
                  width="170"
                  align="center"
                  :key="1"
                  v-if="formInline.transactionType == 1"
                >
                </el-table-column>

                <el-table-column
                  prop="balanceNo"
                  label="支出账单流水号"
                  width="170"
                  align="center"
                  :key="2"
                  v-if="formInline.transactionType == 2"
                >
                </el-table-column>

                <el-table-column
                  prop="vipCode"
                  width="100"
                  label="客户vip号"
                  align="center"
                  :key="3"
                  v-if="formInline.transactionType == 2"
                >
                </el-table-column>
                <el-table-column
                  prop="vipCode"
                  width="100"
                  label="充值人vip号"
                  align="center"
                  :key="4"
                  v-if="formInline.transactionType == 1"
                >
                </el-table-column>
                <el-table-column
                  prop="orderNo"
                  align="center"
                  min-width="140"
                  label="摘要"
                >
                </el-table-column>

                <el-table-column
                  prop="amount"
                  width="140"
                  align="center"
                  label="收取金额（CAD）"
                  :key="5"
                  v-if="formInline.transactionType == 2"
                >
                </el-table-column>

                <el-table-column
                  prop="amount"
                  align="center"
                  width="140"
                  label="充值金额 CAD"
                  :key="6"
                  v-if="formInline.transactionType == 1"
                >
                </el-table-column>
                <el-table-column
                  prop="accountName"
                  align="center"
                  :key="7"
                  v-if="formInline.transactionType == 1"
                  width="200"
                  label="收款类型"
                >
                </el-table-column>

                <el-table-column
                  prop="remark"
                  align="center"
                  width="100"
                  label="备注"
                >
                </el-table-column>
                <el-table-column
                  prop="realName"
                  width="130"
                  align="center"
                  label="操作人"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  align="center"
                  label="取货时间"
                  width="200"
                  :key="8"
                  v-if="formInline.transactionType == 2"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.operatorTime
                        ? changeDate(scope.row.operatorTime)
                        : "时间未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  label="时间"
                  :key="9"
                  width="200"
                  v-if="formInline.transactionType == 1"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.operatorTime
                        ? changeDate(scope.row.operatorTime)
                        : "时间未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="afterBalance"
                  width="200"
                  align="center"
                  label="每笔交易之后账号剩余金额（CAD）"
                >
                </el-table-column>
              </el-table>
              <!-- 流水表格end -->

              <!-- 人员表格start -->
              <!-- <el-table
                v-if="showWhichTable == 2"
                :data="customerList"
                border
                style="width: 100%"
                stripe
              >
                <el-table-column
                  prop="adminId"
                  label="序号"
                  align="center"
                  min-width="50px"
                >
                  <template slot-scope="scope">
                    <span v-text="getIndex(scope.$index)"> </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="头像"
                  header-align="center"
                  width="160px"
                >
                  <template slot-scope="scope">
                    <div class="wrl-flex" align="center">
                      <div>
                        <el-image
                          class="imgRaduis"
                          style="width: 50px; height: 50px"
                          :src="scope.row.photo"
                          fit="contain"
                        ></el-image>
                      </div>
                      <div class="wrl-name">
                        {{ scope.row.nickname }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="真实姓名" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.realName">
                      {{ scope.row.realName }}
                    </div>
                    <div v-else>无</div>
                  </template>
                </el-table-column>
                <el-table-column label="注册时间" align="center" width="100px">
                  <template slot-scope="scope">
                    {{ scope.row.addDate }}
                  </template>
                </el-table-column>
                <el-table-column label="联系方式" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.mobile }}
                  </template>
                </el-table-column>
                <el-table-column label="VIP号" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.vipCode }}
                  </template>
                </el-table-column>
                <el-table-column label="工单配额" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.demandCount }}
                  </template>
                </el-table-column>
                <el-table-column label="余额" align="center" prop="balance">
                </el-table-column>
                <el-table-column label="消费金额" align="center" prop="amount">
                </el-table-column>
                <el-table-column label="派送点" align="center">
                  <template slot-scope="scope">
                    <div>
                      <p>{{ scope.row.deliveryTitle }}</p>
                      <p>{{ scope.row.deliveryAddress }}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="客户备注" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.remark }}
                  </template>
                </el-table-column>
              </el-table> -->
              <!-- 人员表格end -->
            </div>

            <div style="float: right; margin-top: 20px; padding-right: 40px">
              <!-- 流水分页 start -->
              <el-pagination
                v-if="showWhichTable == 1"
                :page-sizes="paginations.page_sizes"
                :page-size="paginations.page_size"
                :layout="paginations.layout"
                :total="paginations.total"
                :current-page="paginations.page_index"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              >
              </el-pagination>
              <!-- 流水分页 end -->
              <!-- 人员分页 start -->
              <el-pagination
                v-if="showWhichTable == 2"
                :page-sizes="paginationsPerson.page_sizes"
                :page-size="paginationsPerson.page_size"
                :layout="paginationsPerson.layout"
                :total="paginationsPerson.total"
                :current-page="paginationsPerson.page_index"
                @current-change="handleCurrentChangePerson"
                @size-change="handleSizeChangePerson"
              >
              </el-pagination>
              <!-- 人员分页 end -->
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <!--指定人员的Dialog start -->
    <el-dialog
      :visible.sync="isShowUserDialog"
      :append-to-body="true"
      width="600px"
    >
      <div slot="title" class="roleData dialogTitle">
        <i class="icon"></i>
        <span class="title-text">人员选择</span>
        <hr />
        <br />
        <span>客户/vipCode：</span>
        <el-input
          v-model="roleInput"
          placeholder="请输入内容"
          style="width: 200px"
          size="small"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="searchRole"
          >查询</el-button
        >
        <el-button type="primary" size="small" @click="setRole">重置</el-button>
        <br /><br /><br />
        <el-table
          :data="roleData"
          border
          :max-height="580"
          ref="multipleTableRole"
          @select="selectRoleOnce"
          @selection-change="selectOptionChange"
          class="table"
        >
          <el-table-column prop="date" type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column
            prop="vipCode"
            label="vipCode"
            align="center"
            width="100"
          >
          </el-table-column>

          <el-table-column
            prop="realName"
            label="客户"
            align="center"
            min-width="100"
          >
          </el-table-column>
        </el-table>

        <div>
          <el-pagination
            class="pagination"
            background
            @size-change="rHandleSizeChange"
            @current-change="rHandleCurrentChange"
            :current-page="rolePaginations.page_index"
            :page-sizes="rolePaginations.page_sizes"
            :page-size="rolePaginations.page_size"
            layout="total, sizes, prev, pager, next"
            :total="rolePaginations.total"
          >
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRole()" type="primary" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="certainRole()" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--指定角色的Dialog end -->
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import * as statisticalApi from "../../api/statistical";
import * as order from "@/api/order";

export default {
  data() {
    return {
      // 表单
      formInline: {
        transactionType: "1",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: "",
      },

      // 人员数组
      peopleArr: [],

      // 选择的时间对应的起始时间戳
      startTime: "",
      endTime: "",

      // 批次数组
      batchArr: [],

      tableData: [],
      customerList: [], //列表
      // 流水分页
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      // 人员分页
      paginationsPerson: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },

      deliveryList: [], // 派送点列表
      showWhichTable: 1, // 展示哪个表格 1流水2人员
      loading: false,

      // F7 人员选择弹框
      isShowUserDialog: false,
      // F7 人员选择弹框 角色名称 搜索字段
      roleInput: "",
      // F7 人员选择弹框 表格数据
      roleData: [],
      //F7分页 需要给分页组件传的信息
      rolePaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [10, 20, 50, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      rowSelection: [],
      howManyTotal: 0,
      listArr: [],
      rechargeColumns: [
        { title: "充值账单流水号", key: "balanceNo" },
        { title: "充值人vip号", key: "vipCode" },
        { title: "摘要", key: "orderNo" },
        { title: "充值金额 CAD", key: "amount" },
        { title: "收款类型", key: "accountName" },
        { title: "备注", key: "remark" },
        { title: "操作人", key: "realName" },
        { title: "时间", key: "operatorTime" },
        { title: "每笔交易之后账号剩余金额（CAD）", key: "afterBalance" },
        
      ],
      expendColumns: [
        { title: "支出账单流水号", key: "balanceNo" },
        { title: "客户vip号", key: "vipCode" },
        { title: "摘要", key: "orderNo" },
        { title: "收取金额（CAD）", key: "amount" },
        { title: "备注", key: "remark" },
        { title: "操作人", key: "realName" },
        { title: "取货时间", key: "operatorTime" },
        { title: "每笔交易之后账号剩余金额（CAD）", key: "afterBalance" },
        
      ],
    };
  },
  created() {
    this.getBatchList();
    // this.getBalanceList();
    this.getDeliveryList();
    this.getCustomer();
    this.getRoleList();
  },
  methods: {
    search() {
      this.getBalanceList();
    },

    // 将选择的时间转换为时间戳
    getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },

    // 获得流水列表
    getBalanceList() {
      let param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        type: this.formInline.transactionType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
        vipCode: this.formInline.checkedPerson,
      };
      statisticalApi.getUserBalance(param).then((res) => {
        console.log(res);
        this.paginations.total = res.data.data.pageCount
          ? res.data.data.pageCount
          : 0;
          this.howManyTotal = res.data.data.pageCount;
        if (res.status !== 200) return this.$message.error(res.msg);
        else if (res.data.code !== 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
      });
    },

    // 日期转换
    changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    },

    // 人员 每页多少条切换
    // handleSizeChangePerson(page_size) {
    //   let that = this;
    //   that.paginationsPerson.page_size = page_size;
    //   that.getCustomer();
    // },
    // // 人员 上下分页
    // handleCurrentChangePerson(page) {
    //   let that = this;
    //   that.paginationsPerson.page_index = page;
    //   that.getCustomer();
    // },

    // 获取人员列表
    // getCustomer() {
    //   let that = this;
    //   let data = {
    //     pageIndex: that.paginationsPerson.page_index,
    //     pageSize: that.paginationsPerson.page_size,
    //     nickname: null,
    //     realName: null,
    //     mobile: null,
    //     startTime: null,
    //     endTime: null,
    //     sort: that.sortWay,
    //   };
    //   let val = JSON.parse(localStorage.getItem("userinfo"));
    //   if (val.roleId !== 1) {
    //     data.adminId = val.adminId;
    //   }
    //   customer.getCustomerList(data).then((res) => {
    //     if (res.data.code == 1202) {
    //       that.$router.push("/login");
    //       return;
    //     }
    //     if (res.data.code == 0) {
    //       that.customerList = res.data.data.list;

    //       that.customerList &&
    //         that.customerList.length > 0 &&
    //         that.customerList.forEach(function (val, i) {
    //           val.addDate = mUtils
    //             .formatDate(new Date(val.addTime))
    //             .substring(0, 10);
    //         });
    //       that.paginationsPerson.total = res.data.data.pageCount;
    //     } else {
    //       that.$message.error("获取列表失败");
    //     }
    //   });
    // },

    // 获取派送点 列表
    getDeliveryList() {
      let that = this;
      let data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },

    //表格序号
    getIndex($index) {
      return (
        (this.paginationsPerson.page_index - 1) *
          this.paginationsPerson.page_size +
        $index +
        1
      );
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      // this.getDeliveryList();
    },

    batchChange() {
      // this.getDeliveryList();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

    // 获取客户列表
    getCustomer() {
      let that = this;
      let data = {};
      statisticalApi.getCustomerList(data).then((res) => {
        console.log("993.res", res);

        if (res.data.code == 0) {
          if (res.data.data && res.data.data) {
            that.peopleArr = res.data.data;
            console.log("996", that.peopleArr);
          }
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },

    cancelRole() {
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },

    searchRole() {
      this.getRoleList();
    },

    setRole() {
      this.roleInput = "";
      this.getRoleList();
    },

    // 显示F7弹框 角色选择
    showUserDialog() {
      this.isShowUserDialog = true;
      this.roleInput = "";
    },

    certainRole() {
      console.log(1103, this.rowSelection);
      if (
        this.rowSelection &&
        this.rowSelection[0] &&
        this.rowSelection[0].vipCode
      ) {
        this.formInline.checkedPerson = this.rowSelection[0].vipCode;
      }
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },

    // 角色选择弹框勾选列表
    selectOptionChange(val) {
      this.rowSelection = val;
    },
    selectRoleOnce(selection, row) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.multipleTableRole.toggleRowSelection(del_row, false);
      }
    },

    // 获取人员f7数据
    getRoleList() {
      let param = {
        realName: this.roleInput ? this.roleInput.trim() : "",
        pageIndex: this.rolePaginations.page_index,
        pageSize: this.rolePaginations.page_size,
      };
      statisticalApi.getCustomerList(param).then((res) => {
        if (res.data.code !== 0)
          return this.$message.error("获取人员数据失败: " + res.data.msg);
        if (res.data && res.data.data && res.data.data) {
          this.roleData = res.data.data;
          this.rolePaginations.total = res.data.data.length;
        }
      });
    },

    rHandleSizeChange(page_size) {
      this.rolePaginations.page_size = page_size;
      this.getRoleList();
    },
    rHandleCurrentChange(page) {
      this.rolePaginations.page_index = page;
      this.getRoleList();
    },

        // 批量导出流水
    exportToExcel() {
      let that = this;
      this.getHowMangTotal();
    },

    // 获得所有条数 需要导出的数据
    async getHowMangTotal() {
      let that = this;
      let param = {
        pageIndex: 1,
        pageSize: 400,
        type: this.formInline.transactionType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
        vipCode: this.formInline.checkedPerson,
      };

      let howManyPage = Math.ceil((that.howManyTotal * 1) / 400);

      let listArr = [];

      for (let i = 1; i <= howManyPage; i++) {
        param.pageIndex = i;
        await statisticalApi.getUserBalance(param).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list) {
              res.data.data.list.map((every, index) => {
                every.operatorTime = mUtils
                  .formatDate(new Date(every.operatorTime))
                  .substring(0, 19);
                listArr.push(every);
              });

            }
          }
        });
      }

      that.listArr = listArr;
      let orderName = "统计-流水列表Excel";
      if(param.type == 1){
        that.columnsOrder = that.rechargeColumns;
      }else{
        that.columnsOrder = that.expendColumns;
      }
      mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },
  },
};
</script>
<style  lang="less" scoped>
.contentBlock {
  width: 100%;
  min-height: 100%;
  margin: 20px 50px 50px 30px;
  & .search {
    width: 100%;
    // height:100px;
    // border: solid;
    & #title {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
    }
    & .form {
      margin-top: 20px;
      .search-icon {
        position: absolute;
        right: -56px;
        top: 0px;
      }
    }
  }

  & .bodyContent {
    width: 100%;
    min-height: 400px;
    margin-top: 30px;
    // border: solid;
    .navCalss {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
      margin-bottom: 10px;
    }
  }
}

.dialogTitle {
  padding-bottom: 10px;
  .icon {
    display: block;
    float: left;
    width: 10px;
    height: 20px;
    background: rgb(64, 158, 255);
  }
  .title-text {
    display: inline-block;
    padding: 0 0 6px 10px;
    line-height: 22px;
    font-weight: bold;
    font-size: 20px;
    color: rgb(64, 158, 255);
  }
}
.dialog-footer {
  text-align: center;
  margin-top: -30px;
}
// 穿透
/deep/ .el-dialog__body {
  padding: 0px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// runningWater.vue?5fae4975